import React from "react";

const MoneySection = () => (
  <section className="faqs" id="money" aria-labelledby="money-title">
    <div className="container">
      <div className="section-head">
        <span className="section-num">03</span>
        <h2 className="section-title" id="money-title">
          Pricing &amp; <em>refunds</em>.
        </h2>
      </div>

      <div className="faq-list">
        <details className="faq-item">
          <summary>How much does 42courses cost?</summary>
          <div className="faq-answer">
            <p>Four ways to learn with us:</p>
            <p>
              <strong>Yearly All Courses Pass:</strong> instant access to every
              course on the platform, plus the Community Hub. Pay upfront or via
              a 12-month interest-free payment plan. Your price is locked in for
              as long as you stay subscribed.
            </p>
            <p>
              <strong>Individual courses:</strong> buy a single course outright.
              Includes 3 months of Community Hub access.
            </p>
            <p>
              <strong>Community Hub only:</strong> a lower-cost tier if you
              mainly want the community, the AI tools, and the swipe file (no
              full courses).
            </p>
            <p>
              <strong>Team plans:</strong> for organisations of 5 or more
              learners. <a href="/team_plans">See team plans &rarr;</a>
            </p>
            <p>
              Prices are shown in your local currency on the{" "}
              <a href="/courses">courses page</a>.
            </p>
            <p
              style={{
                fontSize: "13.5px",
                color: "var(--grey-700)",
                borderLeft: "3px solid var(--blue)",
                paddingLeft: "14px",
                marginTop: "14px",
              }}
            >
              <em>
                Quiet bonus: existing All Courses Pass holders also see a{" "}
                <strong>Lifetime Access</strong> upgrade option in their
                profile. It's our way of saying thanks to the superfans who
                don't want to think about renewals ever again.
              </em>
            </p>
          </div>
        </details>

        <details className="faq-item">
          <summary>What's included in the Community Hub?</summary>
          <div className="faq-answer">
            <p>Three things, all updated regularly:</p>
            <p>
              <strong>A community space</strong> to connect with other learners,
              share questions, and discuss the topics we cover.
            </p>
            <p>
              <strong>A swipe file</strong> of curated industry trend reports,
              useful research, and links shared by learners and our team.
            </p>
            <p>
              <strong>A growing suite of AI tools</strong> built around the
              skills we teach. Examples include a briefing tool that helps you
              write better creative briefs, behavioural science applicators, and
              new tools we ship most weeks. Unlimited use, included with All
              Courses Pass and individual course purchases.
            </p>
          </div>
        </details>

        <details className="faq-item">
          <summary>What about a monthly subscription?</summary>
          <div className="faq-answer">
            <p>
              This question gets confusing because "monthly" can mean two
              different things. So:
            </p>
            <p>
              <strong>Pay-as-you-go monthly (start and stop whenever):</strong>{" "}
              we used to offer this. Existing pay-as-you-go subscribers can
              carry on as before, but if you cancel, you won't be able to
              reactivate it. We're no longer offering this option to new
              customers because the maths didn't work for us at that price
              point.
            </p>
            <p>
              <strong>
                12-month payment plan (spread the cost of a yearly pass):
              </strong>{" "}
              this one is alive and well. It's the same Yearly All Courses Pass,
              just paid in 12 monthly instalments instead of upfront,
              interest-free.{" "}
              <strong>
                It's a payment plan, not a pause-and-resume subscription
              </strong>
              , so you can't stop it halfway through. But you do get instant
              access to everything from day one.
            </p>
          </div>
        </details>

        <details className="faq-item">
          <summary>What payment methods do you accept?</summary>
          <div className="faq-answer">
            <p>
              All major debit and credit cards. PayPal if you'd prefer. We can
              also issue invoices for companies, and there's a checkout option
              to <strong>buy a course as a gift for someone else</strong>.
            </p>
          </div>
        </details>

        <details className="faq-item">
          <summary>I received a voucher. How do I redeem it?</summary>
          <div className="faq-answer">
            <p>
              Lucky you. Enter your voucher code at checkout when you sign up
              for a course or subscription, and the discount applies
              automatically.
            </p>
          </div>
        </details>

        <details className="faq-item">
          <summary>What happens if I cancel my subscription?</summary>
          <div className="faq-answer">
            <p>
              Your account essentially gets paused.{" "}
              <strong>
                Any course you've already passed stays accessible to you forever
              </strong>
              , including the certificate. Lessons and courses you started but
              didn't finish remain visible too. You just won't be able to take
              new lessons or new courses until you renew.
            </p>
            <p>Renew later and you pick up exactly where you left off.</p>
          </div>
        </details>

        <details className="faq-item">
          <summary>What if I don't like the course?</summary>
          <div className="faq-answer">
            <p>
              If the course isn't right for you, email{" "}
              <a href="mailto:groundcontrol@42courses.com">
                groundcontrol@42courses.com
              </a>{" "}
              within the first 30 days and we'll happily refund you. We rarely
              have to honour this (most learners stay because the courses do
              what they say on the tin), but the offer stands.
            </p>
            <p>
              You'll usually know whether a course is for you within the first
              lesson or two, so don't feel you have to push through if it isn't
              clicking.
            </p>
          </div>
        </details>

        <details className="faq-item">
          <summary>Can my employer pay for my subscription?</summary>
          <div className="faq-answer">
            <p>
              Yes, and many do. We can issue invoices and provide receipts for
              L&amp;D budget reimbursement. Email{" "}
              <a href="mailto:groundcontrol@42courses.com">
                groundcontrol@42courses.com
              </a>{" "}
              and we'll send you an invoice template you can forward to your
              finance team.
            </p>
          </div>
        </details>

        <details className="faq-item">
          <summary>Are there discounts for students or non-profits?</summary>
          <div className="faq-answer">
            <p>
              Yes. We offer student pricing and discounts for registered
              non-profits. Email us with proof of status and we'll send you a
              discount code.
            </p>
          </div>
        </details>
      </div>
    </div>
  </section>
);

export default MoneySection;
